import Base from 'app/models/base';

export default Base.extend({
  discrepancy() {
    return (this.get('received_units') || 0) - this.get('units');
  },
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_bol_line_item.js